import React from 'react';
import { createFeature, useFlow } from '@edreamsodigeo/frontend-core';

import { FLIGHT_SUMMARY_HOTELS_MAP_META } from '~clientState/ab';
import FlightSummaryHotelsMap from './components/FlightSummaryHotelsMap/FlightSummaryHotelsMap';
import type { FlightSummaryHotelsMapProps } from './components/FlightSummaryHotelsMap/FlightSummaryHotelsMap';
import PixelTracking from '~shared/PixelTracking';
import { TransportType } from '~types';

const EXCLUDED_MARKETING_PORTALS = ['GFS', 'GFSR'];

export type HotelDealsMobileCardContainerMetaProps =
  FlightSummaryHotelsMapProps & {
    transportTypes: TransportType[];
    isMeta: Required<FlightSummaryHotelsMapProps>['isMeta'];
    mktPortal: string;
  };

const FlightSummaryHotelsMapMeta =
  createFeature<HotelDealsMobileCardContainerMetaProps>({
    variations: [null, FlightSummaryHotelsMap],
    version: 1,
    name: FLIGHT_SUMMARY_HOTELS_MAP_META,
  });

export default (props: HotelDealsMobileCardContainerMetaProps) => {
  const flow: 'mobile' | 'desktop' = useFlow();

  const { transportTypes, isMeta, isMultiDestination, mktPortal } = props;

  const isTrain: boolean = transportTypes.includes(TransportType.Train);

  if (
    !isMeta ||
    flow === 'desktop' ||
    isMultiDestination ||
    isTrain ||
    EXCLUDED_MARKETING_PORTALS.includes(mktPortal)
  ) {
    return (
      <PixelTracking
        datameshId="hotels-in-flights_not-displayed"
        googleAnalyticsParams={{
          category: 'flights_summary',
          action: 'hotels_in_flights',
          label: 'hotels-in-flights_not-displayed_pag:summary',
        }}
      />
    );
  }

  return <FlightSummaryHotelsMapMeta {...props} />;
};
